import { createFileRoute, useRouter } from "@tanstack/react-router";

import { parseItemsSearch } from "@/features/content";
import { StoriesListPage } from "@/features/content/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/growth/stories/")({
  validateSearch: strictSearch(parseItemsSearch),
  component: Stories,
});

function Stories() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const router = useRouter();
  return (
    <StoriesListPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace === true })
      }
      hrefOf={(storyId) =>
        router.buildLocation({ to: "/growth/stories/$storyId", params: { storyId } }).href
      }
      onOpen={(storyId) =>
        void router.navigate({ to: "/growth/stories/$storyId", params: { storyId } })
      }
      onNew={() => void router.navigate({ to: "/growth/stories/new" })}
    />
  );
}
